<template>

  <!-- #region::Add circuits to quote modal -->
  <b-modal
    id="circuits-modal"
    ref="circuits-modal"
    title="Agregar circuitos a la cotización"
    centered
    size="xl"
    @hidden="onCloseModal"
  >
    <b-card-text>
      <b-row>
        <b-col
          cols="12"
          class="mb-1"
        >
          <h3>Circuitos</h3>
        </b-col>

        <b-col
          cols="12"
        >
          <b-alert
            show
            variant="info"
          >
            <div class="alert-body">
              <feather-icon
                class="mr-25"
                icon="AlertCircleIcon"
              />
              <span class="ml-25">Las cotizaciones deben tener productos y piezas de la misma ubicación.</span>
            </div>
          </b-alert>
        </b-col>

        <!-- #region begin::Products list -->
        <b-col>
          <QuoteAddingCircuitList
            :can-apply-global-filters="false"
            :can-apply-global-pagination="false"
          />
        </b-col>
        <!-- #endregion end::Products list -->
      </b-row>
    </b-card-text>

    <!-- #region::Footer -->
    <template #modal-footer>
      <b-button
        variant="delete-btn"
        class="delete-btn"
        @click="hideModal"
      >
        Cancelar
      </b-button>
      <b-button
        variant="principal-btn"
        class="principal-btn"
        @click="onAddCircuits"
      >
        {{ addButtonText }}
      </b-button>
    </template>
    <!-- #endregion::Footer -->
  </b-modal>
  <!-- #endregion::Add circuits to quote modal -->

</template>

<script>
// #region Imports
import { mapGetters, mapActions } from 'vuex'
import {
  BRow, BCol, BModal, VBModal, BCardText, BButton, BAlert,
} from 'bootstrap-vue'
import { v4 as uuidv4 } from 'uuid'

import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import QuoteAddingCircuitList from '@/modules/trade/quotes/components/lists/QuoteAddingCircuitList.vue'
// #endregion

export default {
  components: {
    BRow,
    BCol,
    BAlert,
    BModal,
    BButton,
    BCardText,
    QuoteAddingCircuitList,
  },
  directives: {
    'b-modal': VBModal,
  },
  computed: {
    ...mapGetters({
      getQuotePieces: 'quotes/getQuotePieces',
      getQuoteCircuits: 'quotes/getQuoteCircuits',
      getQuoteSelectedCircuits: 'quotes/getQuoteSelectedCircuits',
    }),
    quoteCircuits: {
      get() { return this.getQuoteCircuits },
    },
    selectedCircuits: {
      get() { return this.getQuoteSelectedCircuits },
    },
    quotePieces: {
      get() { return this.getQuotePieces },
    },
    addButtonText() {
      let text = 'Añadir a cotización'
      let totalCircuitsCount = 0

      if (this.quoteCircuits.length >= this.selectedCircuits.length) {
        totalCircuitsCount = this.quoteCircuits.length
      } else {
        totalCircuitsCount = this.selectedCircuits.length
      }

      if (totalCircuitsCount === 0) {
        return text
      }

      text += ` (${totalCircuitsCount})`

      return text
    },
  },
  methods: {
    ...mapActions({
      addQuoteCircuit: 'quotes/addQuoteCircuit',
      cleanSelectedCircuits: 'quotes/cleanSelectedCircuits',
    }),
    showModal() {
      this.$refs['circuits-modal'].show()
    },
    hideModal() {
      this.$refs['circuits-modal'].hide()
    },
    onAddCircuits() {
      this.selectedCircuits.forEach(selectedCircuit => {
        const existsAtIndex = this.quoteCircuits.findIndex(c => c.IdCircuit === selectedCircuit.IdCircuit)

        if (existsAtIndex !== -1) {
          return
        }

        const quoteCircuit = { ...selectedCircuit }

        const quoteCircuitsProducts = []

        const uuidCircuit = uuidv4()

        selectedCircuit.products.forEach(product => {
          // const pieces = [{ ...product.detailCircuit[index].piece }]

          const pieces = []

          product.detailCircuit.forEach(detailCircuit => {
            pieces.push(detailCircuit.piece)
          })
          if (product.Type === 'Usado') {
            this.$set(product, 'unitPriceType', 'PriceLf')
          } else if (product.Type === 'Nuevo') {
            this.$set(product, 'unitPriceType', product.PriceMin ? 'PriceMin' : 'PriceMinWholesaler')
          } else {
            this.$set(product, 'unitPriceType', 'PriceMin')
          }

          this.$set(product, 'pieces', pieces)
          this.$set(product, 'uuidCircuit', uuidCircuit)
          this.$set(product, 'unitPrice', 0)

          quoteCircuitsProducts.push({ ...product })
        })

        quoteCircuit.products = quoteCircuitsProducts
        this.$set(quoteCircuit, 'uuid', uuidCircuit)
        this.$set(quoteCircuit, 'total', 0)
        this.addQuoteCircuit(quoteCircuit)
      })
      this.hideModal()
    },
    onCloseModal() {
      this.cleanSelectedCircuits()
    },
    showToast(title, text, variant) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title, text, variant, icon: 'BellIcon',
        },
      })
    },
  },
}
</script>
